import { apiFetch } from '../../../utility'

export function getDataRefs(dispatch, moduleIdent, refIdent) {
    const url = `api/Portal/GetDataRefs?moduleIdent=${moduleIdent}&refIdent=${refIdent}`;
    return apiFetch(dispatch, url);
}